import styled from 'styled-components';
import AuthProvider from '../../hooks/AuthProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LeftMenuMobileNavigation from './LeftMenuMobileNavigation';
import history from '../../routes/helper/history';
import CONSTANTS from '../../constants';
import { AlertToast } from '../AlertToast';
import { ClientSession } from '../../client/clientSession';

export const Button = styled.button`
  border: none;
  border-radius: 8px;
  background: ${props => (props.primary ? 'palevioletred' : '#9b59b6')};
  color: #fff;
  margin: 20px;
  font-size: 20px;
  font-weight: bold;
  padding: .6rem 3rem;
  :hover {
    background: #f44660;
  }
`;

export const Name = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  p{
    padding: 0 1rem ;
  }
`;

/**
 *
 * @param links
 * @returns {JSX.Element}
 * @constructor
 *
 * This is the main menu, to edit the side menu on the right, use the prefix Left*,
 * if you need to edit the style, use Sass
 * LeftMenuDesktopNavigation
 * LeftMenuMobileNavigation
 */
const NavBar = ({ links }) => {
  const { handleLogout } = AuthProvider();
  const user = ClientSession.user;

  return (
    <header className="navbar">
      <LeftMenuMobileNavigation links={links} />
      <AlertToast />
      <div className="user">
        <div className="notifications icon-button">
          {/* <FontAwesomeIcon icon={["fa", "bell"]} /> */}
        </div>
        <div className="messages icon-button">
          {/* <FontAwesomeIcon icon={["fa", "paper-plane"]} /> */}
        </div>
        <div className="profile">
          <Name
            className="profile-icon icon-button"
            onClick={() => history.push(CONSTANTS.APP.PROFILE)}
          >
            <FontAwesomeIcon icon={['fa', 'user-alt']} />{' '}
            <p>{user.username}</p>
          </Name>

          <Button onClick={handleLogout}>Sair</Button>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
